<template>
<m-pageframe
    :title="title"
>
<v-container
    v-if="settings != null"
>

    <v-text-field
        label="Organization"
        :value="organization_label"
        disabled
        readonly
        autocomplete="off"
    />

    <v-text-field
        label="Keyword"
        readonly
        disabled
        v-model="settings.keyword"
        autocomplete="off"
    >

        <span
            slot="append-outer"
            v-if="!is_offers42"
        >
            
            <v-icon
                v-on:click="onClickEditKeyword"
                color="primary"
            >
                mdi-lead-pencil
            </v-icon>

        </span>

    </v-text-field>

    <v-select
        label="Match Type"
        :items="$rc.enumChoices('keyword_match_type',false)"
        v-model="settings.match_type"
        v-on:change="put"
    />

    <div
        v-if="is_offers42"
    >
        <b>Important</b>:  OFFERS42 is a built in age gated keyword and can only be modified in limited ways (the auto reply can be edited and you can add respondants to a list).
    </div>

    <v-switch
        label="Keyword Enabled"
        v-model="settings.enabled"
        v-on:change="put"
        :disabled="is_offers42"
    />

    <v-switch
        label="Robust Age Gate"
        v-model="robust_age_gate"
        v-on:change="onChangeRobustAgeGateSwitch"
        :disabled="is_offers42"
    />

    <m-edit-text
        v-if="robust_age_gate"
        label="Minimum Age (years)"
        integer
        v-model="settings.robust_age_gate"
        v-on:input="put"
        :read_only="is_offers42"
    />

    <v-switch
        label="Automatically ask for consent (opt in)"
        v-model="settings.enabled_opt_in"
        v-on:change="put"
        :disabled="is_offers42"
    />

    <div
        v-show="settings.enabled_opt_in"
    >
        <m-edit-message-patterns-compact
            label="Opt In Message Patterns"
            v-model="settings.opt_in_specimen_patterns"
            context="keyword-auto-response"
            v-on:input="put"
            :disabled="is_offers42"
        />

        <m-edit-blobs
            style="margin-top: 15px"
            v-model="settings.opt_in_blob_ids"
            :process_media="true"
            :externally_visible="true"
            :allow_multiple="false"
            v-on:input="put"
            v-if="!is_offers42"
        />

        <div
            style="margin-top: 15px; margin-bottom: 5px;"
        >
            <b>Accepted Opt-in Responses</b>
        </div>

        <div
            v-if="settings.opt_in_responses == 0"
        >
            There are no accepted opt-in responses
        </div>

        <v-chip
            v-for="(word, index) in settings.opt_in_responses"
            :key="'opt_in'+index"
            :close="offers42"
            v-on:click:close="onRemoveOptInResponse(word)"
            style="margin-right: 5px"
        >
            {{word}}
        </v-chip>

        <m-icon-bar
            v-if="!is_offers42"
            v-on:add="onClickAddOptInResponse"
        />

        <div
            style="margin-top: 15px; margin-bottom: 5px;"
        >
            <b>Consent(s) Granted</b>
        </div>

        <v-checkbox
            label="Conversational"
            v-model="settings.opt_in_specimen_grants_conversational_consent"
            v-on:change="put"
            style="margin-bottom: -25px"
            :disabled="is_offers42"
        >
        </v-checkbox>

        <v-checkbox
            label="Informational"
            v-model="settings.opt_in_specimen_grants_informational_consent"
            v-on:change="put"
            style="margin-bottom: -25px"
            :disabled="is_offers42"
        >
        </v-checkbox>

        <v-checkbox
            label="Promotional"
            v-model="settings.opt_in_specimen_grants_promotional_consent"
            v-on:change="put"
            :disabled="is_offers42"
        >
        </v-checkbox>
    </div>

    <v-switch
        label="Add to list"
        v-model="settings.enabled_add_to_list"
        v-on:change="put"
    />

    <div
        v-show="settings.enabled_add_to_list"
    >
        <v-select
            label="List to add respondant to"
            v-model="settings.add_to_list_id"
            :items="list_choices"
            v-on:change="put"
        />
    </div>

    <v-switch
        label="Set Consent State"
        v-model="settings.enabled_set_consent_state"
        v-on:change="put"
        :disabled="is_offers42"
    />

    <div
        v-if="settings.enabled_set_consent_state"
    >
        <v-select
            label="Set Conversational State To"
            :items="$rc.enumChoices('consent_state_change',false)"
            v-model="settings.set_consent_state_conversational"
            v-on:change="put"
        />

        <v-select
            label="Set Informational State To"
            :items="$rc.enumChoices('consent_state_change',false)"
            v-model="settings.set_consent_state_informational"
            v-on:change="put"
        />

        <v-select
            label="Set Promotional State To"
            :items="$rc.enumChoices('consent_state_change',false)"
            v-model="settings.set_consent_state_promotional"
            v-on:change="put"
        />
    </div>

    <v-switch
        :label="settings.enabled_opt_in ? 'Send Auto Response (after opt-in received)' : 'Send Auto Response'"
        v-model="settings.enabled_auto_response"
        v-on:change="put"
        :disabled="is_offers42"
    />

    <m-edit-message-patterns-compact
        v-show="settings.enabled_auto_response"
        label="Auto Response Message Patterns"
        v-model="settings.auto_response_patterns"
        context="keyword-auto-response"
        v-on:input="put"
    />

    <m-edit-blobs
            style="margin-top: 15px"
            v-model="settings.auto_response_blob_ids"
            :process_media="true"
            :externally_visible="true"
            :allow_multiple="false"
            v-on:input="put"
        />

    <m-keyword-edit-dialog
            label="Change Keyword"
            ref="keyword-dialog"
            action_label="Change"
            :organization_id="$route.params.organization_id"
            v-on:ok="changeKeyword"
        />

    <div
        style="text-align: right; margin-top: 15px;"
    >
        <v-btn
            v-on:click="onClickReturn"
        >
            Return to All Keyword Settings
        </v-btn>
    </div>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {

    data() {
        return {
            organization_label: null,
            settings: null,
            list_choices: [],
            robust_age_gate: false,
        }
    },

    mounted () {
        this.update();

        this.$rc.rest({
            'spinner': false,
            'endpoint': 'LIST: /api/v1/lists',
        
            'params' : {
                    'organization_id': this.$route.params.organization_id
                },
        
            'on_success': (data) => {
                    let results = data.results;

                    let ret = [];

                    for ( let i = 0; i < results.length; i++ )
                    {
                        ret.push({
                            'value': results[i].list_id,
                            'text': results[i].list_internal_label,
                        });
                    }

                    this.list_choices = ret;
                },
        
            'on_error': 'Unable to get lists',
        });

    },

    methods: {
        update() {
            this.$rc.showSpinner();
            
            this.$rc.rest(
                'GET-PROFILE: /keyword-auto-response/settings',
            
                {
                    'organization_id' : this.$route.params.organization_id,
                    'keyword' : this.$route.params.keyword,
                },
            
                (data) => {
                    this.$rc.hideSpinner();

                    this.organization_label = data.organization_label;
                    this.settings = data.settings;
                    this.robust_age_gate = data.settings.robust_age_gate != null;
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to get settings profile');
                },
            );
        },

        put: _.debounce(function()
        {
            this.$rc.rest(
                'PUT: /keyword-auto-response/settings',
            
                this.settings,
            
                (data) => {
                },
            
                () => {
                    this.$rc.alert('Error','Unable to save keyword settings');
                },
            );
        },500),

        onClickEditKeyword()
        {
            this.$refs['keyword-dialog'].showDialog(this.settings.keyword);
        },
        
        changeKeyword(new_keyword)
        {
            let old_keyword = this.settings.keyword;

            let params = this.settings;
            params.old_keyword = old_keyword;
            params.keyword = new_keyword;

            this.$rc.rest(
                'PUT: /keyword-auto-response/settings',
            
                params,
            
                (data) => {
                    this.$router.push({
                            'name': 'edit-keyword-auto-response',
                            'params' : {
                                'organization_id' : this.$route.params.organization_id,
                                'keyword' : new_keyword,
                            }
                        });
                },
            
                () => {
                    this.$rc.alert('Error','Unable to change keyword');
                },
            );
        },

        onClickReturn()
        {
            this.$router.push({
                'name': 'settings-organization-keyword-auto-responses',
                'params' : {
                    'organization_id' : this.$route.params.organization_id,
                }
            });
        },

        onRemoveOptInResponse(word)
        {
            let ret = [];

            for ( let i = 0; i < this.settings.opt_in_responses.length; i++ )
            {
                let cur = this.settings.opt_in_responses[i];

                if ( cur == word ) 
                    continue;

                ret.push(cur)
            }


            this.settings.opt_in_responses = ret;
            this.put();
        },

        onClickAddOptInResponse()
        {
             this.$rc.prompt({
                'title' : 'New accepted keyword auto response',
                'label' : 'New accepted keyword auto response',
                'value' : 'YES',
                'after_prompt' : (value) => {
                    if ( value.trim().length == 0 )
                        return;

                    this.settings.opt_in_responses.push(value.trim().toUpperCase());
                    this.put();
                }
            });
        },

        onChangeRobustAgeGateSwitch(value)
        {
            if ( value == false )
            {
                this.settings.robust_age_gate = null;
                this.put();
            }
            else
            {
                this.settings.robust_age_gate = 21;
                this.put();
            }
        }
    },

    computed: {
        
        title() {
            if ( this.settings == null ) return 'Custom Keyword Settings';
            return 'Custom Keyword Settings: '+this.settings.keyword;
        },

        is_offers42()
        {
            if ( this.settings == null ) return false;
            return (''+this.settings.keyword.toLowerCase()) == 'offers42';
        },

    },
}
</script>

<style lang="scss" scoped>
</style>